export default "__VITE_ASSET__kaTzxFHn__"